import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DropdownOptions from "../../../../../constants/DropdownOptions";
import { commodityListAction, deleteCommAction, editCommodityAction } from "../../../../../modules/commodities/action";
import AllMainFarmSelectedDialog from "../../../../Common/AllMainFarmSelectedDialog";
import { isSuperAdmin } from "../../../../Common/CheckAuthorization";
import TabHeaderAndButton from "../../../../Common/TabHeaderAndButton";
import CreateTable from "../../../../CreateTable";
import ConfirmationDialog from "../../../../FormElement/ConfirmationDialog";
import Loader from "../../../../Loader";



class CommodityView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      headerRows: {
        //updatedAt: "Last Updated",
        name: "Name",
        lbsPerBushel: "lbs Per Bushel"
      },
      order: "desc",
      orderBy: "id"
    };
  }

  componentDidMount() {
    const { commodityListAction } = this.props;
    commodityListAction();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.rowComm &&
      this.props.rowComm !== nextProps.rowComm &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
  }

  deleteRow = id => {
    this.setState({
      open: true,
      id: id
    });
  };

  handleClose = () => {
    this.setState({
      open: false
    });
  };

  handleOk = () => {
    const { id } = this.state;
    this.handleClose();
    this.props.deleteCommAction(id);
  };

  editRow = id => {
    const { rowComm } = this.props;
    const requiredData = rowComm.find(commodity => commodity.id === id);
    this.props.editCommodityAction(requiredData);
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };

  render() {
    const { rowComm } = this.props;
    const { fetchingComplete, order, orderBy, open } = this.state;
    const prevPath = "farmsetup/farminformation",
      currentPage = "/commodities";
    return (
      <div className="ticket-body">
        <ConfirmationDialog
          open={open}
          handleClose={this.handleClose}
          handleOk={this.handleOk}
        />
        <TabHeaderAndButton
          header="Commodities"
          path={`/${prevPath}${currentPage}/create`}
          btnLabel="New commodity"
        />
        {isSuperAdmin() && this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id ? (
          <AllMainFarmSelectedDialog/>
        ) : (
            <div>
              {fetchingComplete ? (
                <CreateTable
                  name="sdgsdf"
                  order={order}
                  orderBy={orderBy}
                  headerRows={this.state.headerRows}
                  rowData={rowComm}
                  //delete={this.deleteRow}
                  location={`${prevPath}${currentPage}/edit`}
                  //edit={this.editRow}
                  onRequestSort={this.handleRequestSort}
                  isMenuRequired={false}
                />
              ) : (
                <Loader />
              )}
            </div>
            )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    rowComm: state.commodityReducer.commList,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { commodityListAction, deleteCommAction, editCommodityAction },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommodityView);



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/Commodities/CommodityView.js